import React from 'react';
import Table from 'components/Table';
import {useDispatch, useSelector} from 'react-redux';
import Toogle from 'components/Checkbox/Toggle';
import {updateFolder} from 'actions/folderActions';

import {normalizeLanguageCode, normalizePageFolderLanguages, PageTypes} from 'enums';
import {RoleTypes} from '../enums';

const Sitemap = ({}) => {
  const folders = useSelector((state) => state.folders.folders);
  const dispatch = useDispatch();
  const handleChange = (language) => {
    const folder = folders.find((f) => f.subDomain === language.subDomain);
    if (!folder) return;
    const code = normalizeLanguageCode(language.code);
    if (!code) return;
    const nextFolder = {
      ...folder,
      languages: normalizePageFolderLanguages(folder.languages).map((item) =>
        item.code === code ? {...item, isActive: !item.isActive} : item
      ),
    };
    dispatch(updateFolder(folder._id, nextFolder));
  };

  const columns = [
    {
      headcolumClass: 'bg-gray4',
      bodyClass: 'bg-white',
      headerName: 'Type',
      field: 'pageType',
      width: '100',
    },
    {
      headcolumClass: 'bg-gray4',
      bodyClass: 'bg-white',
      headerName: 'Name',
      field: 'title',
      width: '120',
      uppercase: true,
    },
    {
      headcolumClass: 'bg-gray4',
      bodyClass: 'bg-white',
      headerName: 'Url',
      width: '240',
      render: (row) =>
        `https://${row.subDomain}.jidipi.com/${row.code.toLowerCase()}`,
    },
    {
      headcolumClass: 'bg-gray4',
      bodyClass: 'bg-white',
      headerName: 'Active',
      render: (row) => (
        <Toogle
          disabled={row.code === 'EN'}
          enabled={row.isActive}
          handleChange={(e) => {
            handleChange(row);
          }}
        />
      ),
      width: 100,
    },
  ];

  const singeSitemap = (title, type) => {
    const folder = folders.filter((f) => {
      if (type === RoleTypes.Post) {
        return (
          f.pageType === PageTypes.Product || f.pageType === PageTypes.Project
        );
      }
      return f.pageType === type;
    });
    const data = folder.reduce((list, current) => {
      const languages = normalizePageFolderLanguages(current.languages).map((language) => ({
        ...language,
        pageType: current.pageType,
        subDomain: current.subDomain,
        title: current.title,
      }));

      list = [...list, ...languages];
      return list;
    }, []);

    return (
      <div className="dashboard-list">
        <div className="download-icon d-flex align-items-center  ">
          <h6 className="text-center w-100">{title}</h6>
        </div>
        <div className="table-responsive site-map-lis">
          <Table
            columns={columns}
            data={data}
            className="table-bordered text-center mb-0"
            headerClass="bg-gray4"
          />
        </div>
      </div>
    );
  };

  return (
    <div className="row">
      <div className="col-md-6">
        {singeSitemap(RoleTypes.Post, RoleTypes.Post)}
      </div>
      <div className="col-md-6">
        {singeSitemap(RoleTypes.Information, RoleTypes.Information)}
      </div>

      <div className="col-md-6">
        {singeSitemap(RoleTypes.Company, RoleTypes.Company)}
      </div>
    </div>
  );
};

export default Sitemap;
